const WarningIcon = () => {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7Z"
				fill="#FFB352"
			/>
			<path
				d="M6.99883 2.97485C7.28878 2.97485 7.52383 3.2099 7.52383 3.49985V7.69985C7.52383 7.9898 7.28878 8.22485 6.99883 8.22485C6.70888 8.22485 6.47383 7.9898 6.47383 7.69985V3.49985C6.47383 3.2099 6.70888 2.97485 6.99883 2.97485Z"
				fill="white"
			/>
			<path
				d="M6.99883 10.4999C7.38543 10.4999 7.69883 10.1865 7.69883 9.79985C7.69883 9.41325 7.38543 9.09985 6.99883 9.09985C6.61223 9.09985 6.29883 9.41325 6.29883 9.79985C6.29883 10.1865 6.61223 10.4999 6.99883 10.4999Z"
				fill="white"
			/>
		</svg>
	);
};

export default WarningIcon;
